import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extractNumericValue'
})
export class ExtractNumericValuePipe implements PipeTransform {

  transform(value: string): string {
    const match = value.match(/[\d.]+/);
    return match ? match[0] : '';
  }

}
